
import { t } from "@/plugins/i18n";
export default interface BankStatus {
  id: number;
  name: string;
}

export const bankStatusDefaultProps: BankStatus = {
  id: 0,
  name: "",
};

export const bankStatusDefaultFilterProps: BankStatus = {
  id: 0,
  name: t("Osszes"),
};
